import CarInfoCard from './CarInfoCard'

export default CarInfoCard
